var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.204 19.222l-4.209-4.209a1.281 1.281 0 1 1 1.812-1.811l9.334 9.333 9.333-9.333a1.281 1.281 0 1 1 1.812 1.811l-4.527 4.528 3.9 3.9a1.281 1.281 0 0 1-1.812 1.812l-3.9-3.9-3.9 3.9c-.5.5-1.312.5-1.812 0l-4.22-4.219-4.218 4.22a1.281 1.281 0 0 1-1.812-1.813l4.219-4.219zM7.687 5.766h26.907a4.484 4.484 0 0 1 4.484 4.484v19.219a4.484 4.484 0 0 1-4.484 4.484H7.687a4.484 4.484 0 0 1-4.484-4.484V10.25a4.484 4.484 0 0 1 4.485-4.484zm0 3.843a.64.64 0 0 0-.64.641v19.219c0 .354.287.64.64.64h26.907a.64.64 0 0 0 .64-.64V10.25a.64.64 0 0 0-.64-.64H7.687z","transform":"translate(-3 -5)"}));
}

Mail.defaultProps = {"viewBox":"0 0 37 29"};

module.exports = Mail;

Mail.default = Mail;
